import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalsMenu',
  setup(__props) {

const route = useRoute();

function getPage(path: string): string {
  switch (path) {
    case '/goals':
      return 'List';
  }
  return '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { app: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_breadcrumbs, {
        items: ['Goals', getPage(_unref(route).path)]
      }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})